/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlaskit+theme
import { layers as akLayers } from '@atlaskit/theme/constants';

const mobileBannerIndex = 100;

export const layers: {
	readonly banner: 200;
	readonly card: 100;
	readonly dialog: 300;
	readonly navigation: 200;
	// left sidebar overrides the bottom shadow of navigation without this
	readonly leftSidebar: number;
	// right sidebar shows on top of navigation elements without this
	readonly rightSidebar: number;
	readonly layer: 400;
	readonly blanket: 500;
	readonly modal: 510;
	readonly flag: 600;
	readonly spotlight: 700;
	readonly tooltip: 9999;
	readonly mobileBanner: 100;
} = {
	banner: akLayers.navigation(),
	card: akLayers.card(),
	dialog: akLayers.dialog(),
	navigation: akLayers.navigation(),
	// left sidebar overrides the bottom shadow of navigation without this
	leftSidebar: akLayers.navigation() - 1,
	// right sidebar shows on top of navigation elements without this
	rightSidebar: akLayers.navigation() - 1,
	layer: akLayers.layer(),
	blanket: akLayers.blanket(),
	modal: akLayers.modal(),
	flag: akLayers.flag(),
	spotlight: akLayers.spotlight(),
	tooltip: akLayers.tooltip(),
	mobileBanner: mobileBannerIndex,
} as const;
